
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09c7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09c7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cm529", function(module, exports) {

$parcel$export(module.exports, "AppShell", () => $8feb71ad1d171955$export$2afed54d6b7d68d9);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $hxtH1 = parcelRequire("hxtH1");

var $fqjAj = parcelRequire("fqjAj");

var $hiiR1 = parcelRequire("hiiR1");
var $8feb71ad1d171955$var$__defProp = Object.defineProperty;
var $8feb71ad1d171955$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8feb71ad1d171955$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8feb71ad1d171955$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8feb71ad1d171955$var$__defNormalProp = (obj, key, value)=>key in obj ? $8feb71ad1d171955$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8feb71ad1d171955$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8feb71ad1d171955$var$__hasOwnProp.call(b, prop)) $8feb71ad1d171955$var$__defNormalProp(a, prop, b[prop]);
    if ($8feb71ad1d171955$var$__getOwnPropSymbols) {
        for (var prop of $8feb71ad1d171955$var$__getOwnPropSymbols(b))if ($8feb71ad1d171955$var$__propIsEnum.call(b, prop)) $8feb71ad1d171955$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8feb71ad1d171955$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8feb71ad1d171955$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8feb71ad1d171955$var$__getOwnPropSymbols) {
        for (var prop of $8feb71ad1d171955$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8feb71ad1d171955$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8feb71ad1d171955$var$defaultProps = {
    fixed: true,
    padding: "md"
};
const $8feb71ad1d171955$export$2afed54d6b7d68d9 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("AppShell", $8feb71ad1d171955$var$defaultProps, props), { children: children, navbar: navbar, header: header, footer: footer, aside: aside, fixed: fixed, zIndex: zIndex, padding: padding, navbarOffsetBreakpoint: navbarOffsetBreakpoint, asideOffsetBreakpoint: asideOffsetBreakpoint, className: className, styles: styles, classNames: classNames, unstyled: unstyled, hidden: hidden, layout: layout, variant: variant } = _a, others = $8feb71ad1d171955$var$__objRest(_a, [
        "children",
        "navbar",
        "header",
        "footer",
        "aside",
        "fixed",
        "zIndex",
        "padding",
        "navbarOffsetBreakpoint",
        "asideOffsetBreakpoint",
        "className",
        "styles",
        "classNames",
        "unstyled",
        "hidden",
        "layout",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $fqjAj.default)({
        padding: padding,
        fixed: fixed,
        navbarOffsetBreakpoint: navbarOffsetBreakpoint,
        asideOffsetBreakpoint: asideOffsetBreakpoint
    }, {
        styles: styles,
        classNames: classNames,
        unstyled: unstyled,
        name: "AppShell",
        variant: variant
    });
    if (hidden) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hxtH1.AppShellProvider), {
        value: {
            fixed: fixed,
            zIndex: zIndex,
            layout: layout
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $8feb71ad1d171955$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), header, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.body
    }, navbar, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        className: classes.main
    }, children), aside), footer));
});
$8feb71ad1d171955$export$2afed54d6b7d68d9.displayName = "@mantine/core/AppShell";

});
parcelRegister("fqjAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3a879daee46ea97$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $2vpKc = parcelRequire("2vpKc");
var $d8Ix8 = parcelRequire("d8Ix8");
var $b3a879daee46ea97$var$__defProp = Object.defineProperty;
var $b3a879daee46ea97$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b3a879daee46ea97$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b3a879daee46ea97$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b3a879daee46ea97$var$__defNormalProp = (obj, key, value)=>key in obj ? $b3a879daee46ea97$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b3a879daee46ea97$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b3a879daee46ea97$var$__hasOwnProp.call(b, prop)) $b3a879daee46ea97$var$__defNormalProp(a, prop, b[prop]);
    if ($b3a879daee46ea97$var$__getOwnPropSymbols) {
        for (var prop of $b3a879daee46ea97$var$__getOwnPropSymbols(b))if ($b3a879daee46ea97$var$__propIsEnum.call(b, prop)) $b3a879daee46ea97$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $b3a879daee46ea97$var$getPositionStyles(props, theme) {
    const padding = (0, $d8Ix8.getSize)({
        size: props.padding,
        sizes: theme.spacing
    });
    const navbarOffset = props.navbarOffsetBreakpoint ? (0, $d8Ix8.getSize)({
        size: props.navbarOffsetBreakpoint,
        sizes: theme.breakpoints
    }) : null;
    const asideOffset = props.asideOffsetBreakpoint ? (0, $d8Ix8.getSize)({
        size: props.asideOffsetBreakpoint,
        sizes: theme.breakpoints
    }) : null;
    if (!props.fixed) return {
        padding: padding
    };
    const navbarBreakpointValue = (0, $2vpKc.getBreakpointValue)(navbarOffset);
    const asideBreakpointValue = (0, $2vpKc.getBreakpointValue)(asideOffset);
    return $b3a879daee46ea97$var$__spreadValues({
        minHeight: "100vh",
        paddingTop: `calc(var(--mantine-header-height, 0px) + ${padding})`,
        paddingBottom: `calc(var(--mantine-footer-height, 0px) + ${padding})`,
        paddingLeft: `calc(var(--mantine-navbar-width, 0px) + ${padding})`,
        paddingRight: `calc(var(--mantine-aside-width, 0px) + ${padding})`
    }, navbarBreakpointValue === asideBreakpointValue ? {
        [`@media (max-width: ${(0, $2jkdX.em)(navbarBreakpointValue - 1)})`]: {
            paddingLeft: padding,
            paddingRight: padding
        }
    } : {
        [`@media (max-width: ${(0, $2jkdX.em)(navbarBreakpointValue - 1)})`]: {
            paddingLeft: padding
        },
        [`@media (max-width: ${(0, $2jkdX.em)(asideBreakpointValue - 1)})`]: {
            paddingRight: padding
        }
    });
}
var $b3a879daee46ea97$var$useStyles = (0, $cQG1Y.createStyles)((theme, props)=>({
        root: {
            boxSizing: "border-box"
        },
        body: {
            display: "flex",
            boxSizing: "border-box"
        },
        main: $b3a879daee46ea97$var$__spreadValues({
            flex: 1,
            width: "100vw",
            boxSizing: "border-box"
        }, $b3a879daee46ea97$var$getPositionStyles(props, theme))
    }));
var $b3a879daee46ea97$export$2e2bcd8739ae039 = $b3a879daee46ea97$var$useStyles;

});


parcelRegister("gebf7", function(module, exports) {

$parcel$export(module.exports, "Burger", () => $bd06acc407fe0695$export$3990fdb7137d85ae);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $4nUn9 = parcelRequire("4nUn9");

var $5etRf = parcelRequire("5etRf");
var $bd06acc407fe0695$var$__defProp = Object.defineProperty;
var $bd06acc407fe0695$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bd06acc407fe0695$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bd06acc407fe0695$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bd06acc407fe0695$var$__defNormalProp = (obj, key, value)=>key in obj ? $bd06acc407fe0695$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bd06acc407fe0695$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($bd06acc407fe0695$var$__hasOwnProp.call(b, prop)) $bd06acc407fe0695$var$__defNormalProp(a, prop, b[prop]);
    if ($bd06acc407fe0695$var$__getOwnPropSymbols) {
        for (var prop of $bd06acc407fe0695$var$__getOwnPropSymbols(b))if ($bd06acc407fe0695$var$__propIsEnum.call(b, prop)) $bd06acc407fe0695$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $bd06acc407fe0695$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($bd06acc407fe0695$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $bd06acc407fe0695$var$__getOwnPropSymbols) {
        for (var prop of $bd06acc407fe0695$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $bd06acc407fe0695$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $bd06acc407fe0695$var$defaultProps = {
    size: "md",
    transitionDuration: 300
};
const $bd06acc407fe0695$export$3990fdb7137d85ae = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Burger", $bd06acc407fe0695$var$defaultProps, props), { className: className, opened: opened, color: color, size: size, classNames: classNames, styles: styles, transitionDuration: transitionDuration, variant: variant } = _a, others = $bd06acc407fe0695$var$__objRest(_a, [
        "className",
        "opened",
        "color",
        "size",
        "classNames",
        "styles",
        "transitionDuration",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $4nUn9.default)({
        color: color,
        transitionDuration: transitionDuration
    }, {
        classNames: classNames,
        styles: styles,
        name: "Burger",
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $bd06acc407fe0695$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-opened": opened || void 0,
        className: classes.burger
    }));
});
$bd06acc407fe0695$export$3990fdb7137d85ae.displayName = "@mantine/core/Burger";

});
parcelRegister("4nUn9", function(module, exports) {

$parcel$export(module.exports, "default", () => $331509ce0662995e$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $331509ce0662995e$var$sizes = {
    xs: (0, $2jkdX.rem)(12),
    sm: (0, $2jkdX.rem)(18),
    md: (0, $2jkdX.rem)(24),
    lg: (0, $2jkdX.rem)(34),
    xl: (0, $2jkdX.rem)(42)
};
var $331509ce0662995e$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, transitionDuration: transitionDuration }, { size: size })=>{
    const sizeValue = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $331509ce0662995e$var$sizes
    });
    const _color = color || (theme.colorScheme === "dark" ? theme.white : theme.black);
    return {
        root: {
            borderRadius: theme.radius.sm,
            width: `calc(${sizeValue} + ${theme.spacing.xs})`,
            height: `calc(${sizeValue} + ${theme.spacing.xs})`,
            padding: `calc(${theme.spacing.xs} / 2)`,
            cursor: "pointer"
        },
        burger: {
            position: "relative",
            userSelect: "none",
            boxSizing: "border-box",
            "&, &::before, &::after": {
                display: "block",
                width: sizeValue,
                height: `calc(${sizeValue} / 12)`,
                backgroundColor: _color,
                outline: `${(0, $2jkdX.rem)(1)} solid transparent`,
                transitionProperty: "background-color, transform",
                transitionDuration: `${transitionDuration}ms`,
                "@media (prefers-reduced-motion)": {
                    transitionDuration: theme.respectReducedMotion ? "0ms" : void 0
                }
            },
            "&::before, &::after": {
                position: "absolute",
                content: '""',
                left: 0
            },
            "&::before": {
                top: `calc((${sizeValue} / 3) * -1)`
            },
            "&::after": {
                top: `calc(${sizeValue} / 3)`
            },
            "&[data-opened]": {
                backgroundColor: "transparent",
                "&::before": {
                    transform: `translateY(calc(${sizeValue} / 3)) rotate(45deg)`
                },
                "&::after": {
                    transform: `translateY(calc(-${sizeValue} / 3)) rotate(-45deg)`
                }
            }
        }
    };
});
var $331509ce0662995e$export$2e2bcd8739ae039 = $331509ce0662995e$var$useStyles;

});


parcelRegister("jXwWv", function(module, exports) {

$parcel$export(module.exports, "SpotlightProvider", () => $e87d14c1a4c2875d$export$32e376b6d490e7d9);

var $acw62 = parcelRequire("acw62");

var $6X2G0 = parcelRequire("6X2G0");
var $ke4gU = parcelRequire("ke4gU");

var $cV4Hy = parcelRequire("cV4Hy");

var $awfbW = parcelRequire("awfbW");

var $fehxQ = parcelRequire("fehxQ");

var $4k1i9 = parcelRequire("4k1i9");

var $1H7ml = parcelRequire("1H7ml");
var $e87d14c1a4c2875d$var$__defProp = Object.defineProperty;
var $e87d14c1a4c2875d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e87d14c1a4c2875d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e87d14c1a4c2875d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e87d14c1a4c2875d$var$__defNormalProp = (obj, key, value)=>key in obj ? $e87d14c1a4c2875d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e87d14c1a4c2875d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e87d14c1a4c2875d$var$__hasOwnProp.call(b, prop)) $e87d14c1a4c2875d$var$__defNormalProp(a, prop, b[prop]);
    if ($e87d14c1a4c2875d$var$__getOwnPropSymbols) {
        for (var prop of $e87d14c1a4c2875d$var$__getOwnPropSymbols(b))if ($e87d14c1a4c2875d$var$__propIsEnum.call(b, prop)) $e87d14c1a4c2875d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e87d14c1a4c2875d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e87d14c1a4c2875d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e87d14c1a4c2875d$var$__getOwnPropSymbols) {
        for (var prop of $e87d14c1a4c2875d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e87d14c1a4c2875d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $e87d14c1a4c2875d$export$32e376b6d490e7d9(_a) {
    var _b = _a, { actions: actions, children: children, shortcut: shortcut = "mod + K", query: query, onSpotlightClose: onSpotlightClose, onSpotlightOpen: onSpotlightOpen, onQueryChange: onQueryChange, onActionsChange: onActionsChange, cleanQueryOnClose: cleanQueryOnClose = true, transitionProps: transitionProps = {
        duration: 150
    }, disabled: disabled = false, tagsToIgnore: tagsToIgnore = [
        "INPUT",
        "TEXTAREA",
        "SELECT"
    ], triggerOnContentEditable: triggerOnContentEditable = false } = _b, others = $e87d14c1a4c2875d$var$__objRest(_b, [
        "actions",
        "children",
        "shortcut",
        "query",
        "onSpotlightClose",
        "onSpotlightOpen",
        "onQueryChange",
        "onActionsChange",
        "cleanQueryOnClose",
        "transitionProps",
        "disabled",
        "tagsToIgnore",
        "triggerOnContentEditable"
    ]);
    const timeoutRef = (0, $acw62.useRef)(-1);
    const [_query, setQuery] = (0, $ke4gU.useUncontrolled)({
        value: query,
        defaultValue: "",
        finalValue: "",
        onChange: onQueryChange
    });
    const [_actions, { registerActions: registerActions, removeActions: removeActions, triggerAction: triggerAction }] = (0, $4k1i9.useActionsState)({
        actions: actions,
        onActionsChange: onActionsChange
    });
    const handleQueryChange = (value)=>{
        setQuery(value);
        onQueryChange == null || onQueryChange(value);
    };
    const [opened, { open: open, close: close, toggle: toggle }] = (0, $6X2G0.useDisclosure)(false, {
        onClose: ()=>{
            onSpotlightClose == null || onSpotlightClose();
            if (cleanQueryOnClose) timeoutRef.current = window.setTimeout(()=>{
                handleQueryChange("");
            }, transitionProps.duration || 150);
        },
        onOpen: ()=>{
            onSpotlightOpen == null || onSpotlightOpen();
            window.clearTimeout(timeoutRef.current);
        }
    });
    const ctx = {
        openSpotlight: open,
        closeSpotlight: close,
        toggleSpotlight: toggle,
        registerActions: registerActions,
        removeActions: removeActions,
        triggerAction: triggerAction,
        opened: opened,
        actions: _actions,
        query: _query
    };
    (0, $1H7ml.useSpotlightShortcuts)(shortcut, open, tagsToIgnore, triggerOnContentEditable);
    (0, $cV4Hy.useSpotlightEvents)({
        open: open,
        close: close,
        toggle: toggle,
        registerActions: registerActions,
        removeActions: removeActions,
        triggerAction: triggerAction
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $awfbW.SpotlightContext).Provider, {
        value: ctx
    }, !disabled && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fehxQ.Spotlight), $e87d14c1a4c2875d$var$__spreadValues({
        actions: _actions,
        onClose: close,
        opened: opened,
        query: _query,
        onQueryChange: handleQueryChange,
        transitionProps: transitionProps
    }, others)), children);
}
$e87d14c1a4c2875d$export$32e376b6d490e7d9.displayName = "@mantine/spotlight/SpotlightProvider";

});
parcelRegister("cV4Hy", function(module, exports) {

$parcel$export(module.exports, "useSpotlightEvents", () => $967e748bb6d292e9$export$85356fad003840d3);

var $hkjSU = parcelRequire("hkjSU");
const [$967e748bb6d292e9$export$85356fad003840d3, $967e748bb6d292e9$export$c30017717ce2168e] = (0, $hkjSU.createUseExternalEvents)("mantine-spotlight");
const $967e748bb6d292e9$export$1b120cfeb7d14840 = $967e748bb6d292e9$export$c30017717ce2168e("open");
const $967e748bb6d292e9$export$50d69dc5b51a0095 = $967e748bb6d292e9$export$c30017717ce2168e("close");
const $967e748bb6d292e9$export$ef32d7824d8be52e = $967e748bb6d292e9$export$c30017717ce2168e("toggle");
const $967e748bb6d292e9$export$dde4897a1afd8462 = $967e748bb6d292e9$export$c30017717ce2168e("triggerAction");
const $967e748bb6d292e9$export$4ddbe3c867e0ec27 = $967e748bb6d292e9$export$c30017717ce2168e("registerActions");
const $967e748bb6d292e9$export$ce397953f0306007 = $967e748bb6d292e9$export$c30017717ce2168e("removeActions");
const $967e748bb6d292e9$export$ce22f6f6b0034afd = {
    open: $967e748bb6d292e9$export$1b120cfeb7d14840,
    close: $967e748bb6d292e9$export$50d69dc5b51a0095,
    toggle: $967e748bb6d292e9$export$ef32d7824d8be52e,
    triggerAction: $967e748bb6d292e9$export$dde4897a1afd8462,
    registerActions: $967e748bb6d292e9$export$4ddbe3c867e0ec27,
    removeActions: $967e748bb6d292e9$export$ce397953f0306007
};

});
parcelRegister("hkjSU", function(module, exports) {

$parcel$export(module.exports, "createUseExternalEvents", () => $c9d3ba93067fab06$export$1e78633c070e02d6);

var $acw62 = parcelRequire("acw62");
function $c9d3ba93067fab06$var$dispatchEvent(type, detail) {
    window.dispatchEvent(new CustomEvent(type, {
        detail: detail
    }));
}
const $c9d3ba93067fab06$var$useIsomorphicEffect = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $c9d3ba93067fab06$export$1e78633c070e02d6(prefix) {
    function _useExternalEvents(events) {
        const handlers = Object.keys(events).reduce((acc, eventKey)=>{
            acc[`${prefix}:${eventKey}`] = (event)=>events[eventKey](event.detail);
            return acc;
        }, {});
        $c9d3ba93067fab06$var$useIsomorphicEffect(()=>{
            Object.keys(handlers).forEach((eventKey)=>{
                window.removeEventListener(eventKey, handlers[eventKey]);
                window.addEventListener(eventKey, handlers[eventKey]);
            });
            return ()=>Object.keys(handlers).forEach((eventKey)=>{
                    window.removeEventListener(eventKey, handlers[eventKey]);
                });
        }, [
            handlers
        ]);
    }
    function createEvent(event) {
        return (...payload)=>$c9d3ba93067fab06$var$dispatchEvent(`${prefix}:${String(event)}`, payload[0]);
    }
    return [
        _useExternalEvents,
        createEvent
    ];
}

});


parcelRegister("fehxQ", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $b165c5ddcda6a62a$export$1033c28b5e1c2deb);

var $acw62 = parcelRequire("acw62");

var $iu1L3 = parcelRequire("iu1L3");
var $aCM0s = parcelRequire("aCM0s");
var $5Eq0L = parcelRequire("5Eq0L");
var $8mycu = parcelRequire("8mycu");
var $64A2P = parcelRequire("64A2P");

var $6Lcfd = parcelRequire("6Lcfd");

var $2qf6h = parcelRequire("2qf6h");

var $1CIe8 = parcelRequire("1CIe8");

var $3gCmv = parcelRequire("3gCmv");

var $ZMGGu = parcelRequire("ZMGGu");

var $eOLeI = parcelRequire("eOLeI");
var $b165c5ddcda6a62a$var$__defProp = Object.defineProperty;
var $b165c5ddcda6a62a$var$__defProps = Object.defineProperties;
var $b165c5ddcda6a62a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b165c5ddcda6a62a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b165c5ddcda6a62a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b165c5ddcda6a62a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b165c5ddcda6a62a$var$__defNormalProp = (obj, key, value)=>key in obj ? $b165c5ddcda6a62a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b165c5ddcda6a62a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b165c5ddcda6a62a$var$__hasOwnProp.call(b, prop)) $b165c5ddcda6a62a$var$__defNormalProp(a, prop, b[prop]);
    if ($b165c5ddcda6a62a$var$__getOwnPropSymbols) {
        for (var prop of $b165c5ddcda6a62a$var$__getOwnPropSymbols(b))if ($b165c5ddcda6a62a$var$__propIsEnum.call(b, prop)) $b165c5ddcda6a62a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b165c5ddcda6a62a$var$__spreadProps = (a, b)=>$b165c5ddcda6a62a$var$__defProps(a, $b165c5ddcda6a62a$var$__getOwnPropDescs(b));
var $b165c5ddcda6a62a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b165c5ddcda6a62a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b165c5ddcda6a62a$var$__getOwnPropSymbols) {
        for (var prop of $b165c5ddcda6a62a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b165c5ddcda6a62a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $b165c5ddcda6a62a$var$SpotlightScrollArea(props) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5Eq0L.ScrollArea).Autosize, $b165c5ddcda6a62a$var$__spreadValues({
        mah: "calc(100vh - 18rem)"
    }, props));
}
const $b165c5ddcda6a62a$var$defaultProps = {
    closeOnActionTrigger: true,
    highlightQuery: false,
    size: 600,
    yOffset: 120,
    filter: (0, $ZMGGu.filterActions),
    limit: 10,
    actionComponent: (0, $1CIe8.DefaultAction),
    scrollAreaComponent: $b165c5ddcda6a62a$var$SpotlightScrollArea,
    actionsWrapperComponent: "div",
    zIndex: (0, $iu1L3.getDefaultZIndex)("max"),
    overlayProps: {
        opacity: 0.2,
        blur: 7
    }
};
function $b165c5ddcda6a62a$export$1033c28b5e1c2deb(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Spotlight", $b165c5ddcda6a62a$var$defaultProps, props), { query: query, onQueryChange: onQueryChange, actions: actions, onClose: onClose, opened: opened, classNames: classNames, styles: styles, closeOnActionTrigger: closeOnActionTrigger, highlightQuery: highlightQuery, highlightColor: highlightColor, className: className, searchPlaceholder: searchPlaceholder, searchIcon: searchIcon, filter: filter, nothingFoundMessage: nothingFoundMessage, limit: limit, actionComponent: actionComponent, actionsWrapperComponent: ActionsWrapper, scrollAreaComponent: ScrollAreaComponent, searchInputProps: searchInputProps, variant: variant, radius: radius } = _a, others = $b165c5ddcda6a62a$var$__objRest(_a, [
        "query",
        "onQueryChange",
        "actions",
        "onClose",
        "opened",
        "classNames",
        "styles",
        "closeOnActionTrigger",
        "highlightQuery",
        "highlightColor",
        "className",
        "searchPlaceholder",
        "searchIcon",
        "filter",
        "nothingFoundMessage",
        "limit",
        "actionComponent",
        "actionsWrapperComponent",
        "scrollAreaComponent",
        "searchInputProps",
        "variant",
        "radius"
    ]);
    const [hovered, setHovered] = (0, $acw62.useState)(-1);
    const [IMEOpen, setIMEOpen] = (0, $acw62.useState)(false);
    const { classes: classes, cx: cx } = (0, $eOLeI.default)(null, {
        name: "Spotlight",
        classNames: classNames,
        styles: styles,
        variant: variant
    });
    const resetHovered = ()=>setHovered(-1);
    const handleClose = ()=>{
        resetHovered();
        onClose();
    };
    const filteredActions = filter(query, actions).slice(0, limit);
    const groupedWithLabels = (0, $6Lcfd.getGroupedOptions)(filteredActions).items;
    const groupedActions = groupedWithLabels.map((item)=>item.type === "item" ? item.item : void 0).filter((item)=>item);
    (0, $2qf6h.useDidUpdate)(()=>{
        if (groupedActions.length - 1 < hovered) setHovered(groupedActions.length - 1);
    }, [
        groupedActions.length
    ]);
    const handleInputKeyDown = (event)=>{
        var _a2, _b;
        if (IMEOpen) return;
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setHovered((current)=>current < groupedActions.length - 1 ? current + 1 : 0);
                break;
            case "ArrowUp":
                event.preventDefault();
                setHovered((current)=>current > 0 ? current - 1 : groupedActions.length - 1);
                break;
            case "Enter":
                {
                    event.preventDefault();
                    const action = groupedActions[hovered];
                    (_a2 = action == null ? void 0 : action.onTrigger) == null || _a2.call(action, action);
                    if (((_b = action == null ? void 0 : action.closeOnTrigger) != null ? _b : closeOnActionTrigger) && (action == null ? void 0 : action.onTrigger)) handleClose();
                    break;
                }
            case "Escape":
                event.preventDefault();
                handleClose();
        }
    };
    const handleInputChange = (event)=>{
        onQueryChange(event.currentTarget.value);
        if (hovered === -1) setHovered(0);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aCM0s.Modal), $b165c5ddcda6a62a$var$__spreadValues({
        opened: opened,
        onClose: handleClose,
        padding: 0,
        radius: radius,
        scrollAreaComponent: (0, $aCM0s.Modal).NativeScrollArea,
        classNames: $b165c5ddcda6a62a$var$__spreadProps($b165c5ddcda6a62a$var$__spreadValues({}, classNames), {
            content: cx(classes.content, classNames == null ? void 0 : classNames.content)
        }),
        styles: styles,
        withCloseButton: false
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8mycu.TextInput), $b165c5ddcda6a62a$var$__spreadProps($b165c5ddcda6a62a$var$__spreadValues({
        size: "lg"
    }, searchInputProps), {
        value: query,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onCompositionStart: ()=>setIMEOpen(true),
        onCompositionEnd: ()=>setIMEOpen(false),
        classNames: {
            input: classes.searchInput
        },
        placeholder: searchPlaceholder,
        icon: searchIcon
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ActionsWrapper, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ScrollAreaComponent, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3gCmv.ActionsList), {
        highlightQuery: highlightQuery,
        highlightColor: highlightColor,
        actions: groupedWithLabels,
        actionComponent: actionComponent,
        hovered: hovered,
        query: query,
        nothingFoundMessage: nothingFoundMessage,
        onActionTrigger: (action)=>{
            var _a2;
            action.onTrigger(action);
            ((_a2 = action.closeOnTrigger) != null ? _a2 : closeOnActionTrigger) && handleClose();
        },
        styles: styles,
        classNames: classNames,
        radius: radius,
        variant: variant
    }))));
}
$b165c5ddcda6a62a$export$1033c28b5e1c2deb.displayName = "@mantine/spotlight/Spotlight";

});
parcelRegister("1CIe8", function(module, exports) {

$parcel$export(module.exports, "DefaultAction", () => $12eba599ed2e58f4$export$85677d817cb6b04a);

var $acw62 = parcelRequire("acw62");

var $4W1M8 = parcelRequire("4W1M8");
var $9mTYo = parcelRequire("9mTYo");
var $ezsTf = parcelRequire("ezsTf");
var $cjohz = parcelRequire("cjohz");
var $5etRf = parcelRequire("5etRf");

var $7MiXG = parcelRequire("7MiXG");
var $12eba599ed2e58f4$var$__defProp = Object.defineProperty;
var $12eba599ed2e58f4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $12eba599ed2e58f4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $12eba599ed2e58f4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $12eba599ed2e58f4$var$__defNormalProp = (obj, key, value)=>key in obj ? $12eba599ed2e58f4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $12eba599ed2e58f4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($12eba599ed2e58f4$var$__hasOwnProp.call(b, prop)) $12eba599ed2e58f4$var$__defNormalProp(a, prop, b[prop]);
    if ($12eba599ed2e58f4$var$__getOwnPropSymbols) {
        for (var prop of $12eba599ed2e58f4$var$__getOwnPropSymbols(b))if ($12eba599ed2e58f4$var$__propIsEnum.call(b, prop)) $12eba599ed2e58f4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $12eba599ed2e58f4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($12eba599ed2e58f4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $12eba599ed2e58f4$var$__getOwnPropSymbols) {
        for (var prop of $12eba599ed2e58f4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $12eba599ed2e58f4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $12eba599ed2e58f4$export$85677d817cb6b04a(_a) {
    var _b = _a, { action: action, styles: styles, classNames: classNames, hovered: hovered, onTrigger: onTrigger, highlightQuery: highlightQuery, highlightColor: highlightColor, query: query, radius: radius } = _b, others = $12eba599ed2e58f4$var$__objRest(_b, [
        "action",
        "styles",
        "classNames",
        "hovered",
        "onTrigger",
        "highlightQuery",
        "highlightColor",
        "query",
        "radius"
    ]);
    const { classes: classes } = (0, $7MiXG.default)({
        radius: radius
    }, {
        styles: styles,
        classNames: classNames,
        name: "Spotlight"
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $12eba599ed2e58f4$var$__spreadValues({
        className: classes.action,
        "data-hovered": hovered || void 0,
        tabIndex: -1,
        onMouseDown: (event)=>event.preventDefault(),
        onClick: onTrigger
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9mTYo.Group), {
        noWrap: true
    }, action.icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4W1M8.Center), {
        className: classes.actionIcon,
        "data-hovered": hovered || void 0
    }, action.icon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.actionBody
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ezsTf.Highlight), {
        highlightColor: highlightColor,
        className: classes.actionHighlight,
        highlight: highlightQuery ? query : null
    }, action.title), action.description && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        size: "xs",
        className: classes.actionDescription,
        "data-hovered": hovered || void 0
    }, action.description))));
}
$12eba599ed2e58f4$export$85677d817cb6b04a.displayName = "@mantine/spotlight/DefaultAction";

});
parcelRegister("ezsTf", function(module, exports) {

$parcel$export(module.exports, "Highlight", () => $a9babe86d0f38112$export$39dbc3f558091353);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $cjohz = parcelRequire("cjohz");

var $gOGxt = parcelRequire("gOGxt");

var $2cRhP = parcelRequire("2cRhP");
var $a9babe86d0f38112$var$__defProp = Object.defineProperty;
var $a9babe86d0f38112$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a9babe86d0f38112$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a9babe86d0f38112$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a9babe86d0f38112$var$__defNormalProp = (obj, key, value)=>key in obj ? $a9babe86d0f38112$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a9babe86d0f38112$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a9babe86d0f38112$var$__hasOwnProp.call(b, prop)) $a9babe86d0f38112$var$__defNormalProp(a, prop, b[prop]);
    if ($a9babe86d0f38112$var$__getOwnPropSymbols) {
        for (var prop of $a9babe86d0f38112$var$__getOwnPropSymbols(b))if ($a9babe86d0f38112$var$__propIsEnum.call(b, prop)) $a9babe86d0f38112$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a9babe86d0f38112$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a9babe86d0f38112$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a9babe86d0f38112$var$__getOwnPropSymbols) {
        for (var prop of $a9babe86d0f38112$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a9babe86d0f38112$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a9babe86d0f38112$var$defaultProps = {
    highlightColor: "yellow"
};
const $a9babe86d0f38112$export$d5827cb16f77a523 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Highlight", $a9babe86d0f38112$var$defaultProps, props), { children: children, highlight: highlight, highlightColor: highlightColor, highlightStyles: highlightStyles, unstyled: unstyled } = _a, others = $a9babe86d0f38112$var$__objRest(_a, [
        "children",
        "highlight",
        "highlightColor",
        "highlightStyles",
        "unstyled"
    ]);
    const highlightChunks = (0, $2cRhP.highlighter)(children, highlight);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $a9babe86d0f38112$var$__spreadValues({
        unstyled: unstyled,
        ref: ref,
        __staticSelector: "Highlight"
    }, others), highlightChunks.map(({ chunk: chunk, highlighted: highlighted }, i)=>highlighted ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gOGxt.Mark), {
            unstyled: unstyled,
            key: i,
            color: highlightColor,
            sx: highlightStyles,
            "data-highlight": chunk
        }, chunk) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i
        }, chunk)));
});
$a9babe86d0f38112$export$d5827cb16f77a523.displayName = "@mantine/core/Highlight";
const $a9babe86d0f38112$export$39dbc3f558091353 = (0, $1euea.createPolymorphicComponent)($a9babe86d0f38112$export$d5827cb16f77a523);

});
parcelRegister("gOGxt", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $c3e2502f4d686e3e$export$c9d15bcfc6d42044);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $7TqbY = parcelRequire("7TqbY");

var $hiiR1 = parcelRequire("hiiR1");
var $c3e2502f4d686e3e$var$__defProp = Object.defineProperty;
var $c3e2502f4d686e3e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c3e2502f4d686e3e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c3e2502f4d686e3e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c3e2502f4d686e3e$var$__defNormalProp = (obj, key, value)=>key in obj ? $c3e2502f4d686e3e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c3e2502f4d686e3e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c3e2502f4d686e3e$var$__hasOwnProp.call(b, prop)) $c3e2502f4d686e3e$var$__defNormalProp(a, prop, b[prop]);
    if ($c3e2502f4d686e3e$var$__getOwnPropSymbols) {
        for (var prop of $c3e2502f4d686e3e$var$__getOwnPropSymbols(b))if ($c3e2502f4d686e3e$var$__propIsEnum.call(b, prop)) $c3e2502f4d686e3e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c3e2502f4d686e3e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c3e2502f4d686e3e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c3e2502f4d686e3e$var$__getOwnPropSymbols) {
        for (var prop of $c3e2502f4d686e3e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c3e2502f4d686e3e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c3e2502f4d686e3e$var$defaultProps = {
    color: "yellow"
};
const $c3e2502f4d686e3e$export$c9d15bcfc6d42044 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Mark", $c3e2502f4d686e3e$var$defaultProps, props), { color: color, className: className, unstyled: unstyled, variant: variant } = _a, others = $c3e2502f4d686e3e$var$__objRest(_a, [
        "color",
        "className",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $7TqbY.default)({
        color: color
    }, {
        unstyled: unstyled,
        name: "Mark",
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $c3e2502f4d686e3e$var$__spreadValues({
        component: "mark",
        ref: ref,
        className: cx(classes.root, className)
    }, others));
});
$c3e2502f4d686e3e$export$c9d15bcfc6d42044.displayName = "@mantine/core/Mark";

});
parcelRegister("7TqbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bf1fcac93a8271c$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $5bf1fcac93a8271c$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color })=>({
        root: {
            backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : 2),
            color: theme.colorScheme === "dark" ? theme.colors.dark[9] : "inherit"
        }
    }));
var $5bf1fcac93a8271c$export$2e2bcd8739ae039 = $5bf1fcac93a8271c$var$useStyles;

});


parcelRegister("2cRhP", function(module, exports) {

$parcel$export(module.exports, "highlighter", () => $19b6095676ad17cb$export$1537643e85439bf5);
function $19b6095676ad17cb$var$escapeRegex(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&");
}
function $19b6095676ad17cb$export$1537643e85439bf5(value, _highlight) {
    if (_highlight == null) return [
        {
            chunk: value,
            highlighted: false
        }
    ];
    const highlight = Array.isArray(_highlight) ? _highlight.map($19b6095676ad17cb$var$escapeRegex) : $19b6095676ad17cb$var$escapeRegex(_highlight);
    const shouldHighlight = Array.isArray(highlight) ? highlight.filter((part)=>part.trim().length > 0).length > 0 : highlight.trim() !== "";
    if (!shouldHighlight) return [
        {
            chunk: value,
            highlighted: false
        }
    ];
    const matcher = typeof highlight === "string" ? highlight.trim() : highlight.filter((part)=>part.trim().length !== 0).map((part)=>part.trim()).join("|");
    const re = new RegExp(`(${matcher})`, "gi");
    const chunks = value.split(re).map((part)=>({
            chunk: part,
            highlighted: re.test(part)
        })).filter(({ chunk: chunk })=>chunk);
    return chunks;
}

});


parcelRegister("7MiXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a9bb97a0e5949ef$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $5a9bb97a0e5949ef$var$__defProp = Object.defineProperty;
var $5a9bb97a0e5949ef$var$__defProps = Object.defineProperties;
var $5a9bb97a0e5949ef$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5a9bb97a0e5949ef$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5a9bb97a0e5949ef$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5a9bb97a0e5949ef$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5a9bb97a0e5949ef$var$__defNormalProp = (obj, key, value)=>key in obj ? $5a9bb97a0e5949ef$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5a9bb97a0e5949ef$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5a9bb97a0e5949ef$var$__hasOwnProp.call(b, prop)) $5a9bb97a0e5949ef$var$__defNormalProp(a, prop, b[prop]);
    if ($5a9bb97a0e5949ef$var$__getOwnPropSymbols) {
        for (var prop of $5a9bb97a0e5949ef$var$__getOwnPropSymbols(b))if ($5a9bb97a0e5949ef$var$__propIsEnum.call(b, prop)) $5a9bb97a0e5949ef$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5a9bb97a0e5949ef$var$__spreadProps = (a, b)=>$5a9bb97a0e5949ef$var$__defProps(a, $5a9bb97a0e5949ef$var$__getOwnPropDescs(b));
var $5a9bb97a0e5949ef$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius })=>({
        action: $5a9bb97a0e5949ef$var$__spreadProps($5a9bb97a0e5949ef$var$__spreadValues({
            position: "relative",
            display: "block",
            width: "100%",
            padding: `${(0, $2jkdX.rem)(10)} ${(0, $2jkdX.rem)(12)}`,
            borderRadius: theme.fn.radius(radius)
        }, theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
        })), {
            "&[data-hovered]": $5a9bb97a0e5949ef$var$__spreadValues({
                backgroundColor: theme.fn.primaryColor(),
                color: theme.white
            }, theme.fn.hover({
                backgroundColor: theme.fn.primaryColor()
            }))
        }),
        actionDescription: {
            color: theme.fn.dimmed(),
            "&[data-hovered]": {
                color: theme.white,
                opacity: 0.7
            }
        },
        actionIcon: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
            "&[data-hovered]": {
                color: theme.white,
                opacity: 0.7
            }
        },
        actionBody: {},
        actionHighlight: {
            "& [data-highlight]": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.black
            }
        }
    }));
var $5a9bb97a0e5949ef$export$2e2bcd8739ae039 = $5a9bb97a0e5949ef$var$useStyles;

});


parcelRegister("3gCmv", function(module, exports) {

$parcel$export(module.exports, "ActionsList", () => $26109f9d94d24593$export$5a3594759df1bd02);

var $acw62 = parcelRequire("acw62");

var $cjohz = parcelRequire("cjohz");

var $kREKv = parcelRequire("kREKv");
var $26109f9d94d24593$var$__defProp = Object.defineProperty;
var $26109f9d94d24593$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $26109f9d94d24593$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $26109f9d94d24593$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $26109f9d94d24593$var$__defNormalProp = (obj, key, value)=>key in obj ? $26109f9d94d24593$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $26109f9d94d24593$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($26109f9d94d24593$var$__hasOwnProp.call(b, prop)) $26109f9d94d24593$var$__defNormalProp(a, prop, b[prop]);
    if ($26109f9d94d24593$var$__getOwnPropSymbols) {
        for (var prop of $26109f9d94d24593$var$__getOwnPropSymbols(b))if ($26109f9d94d24593$var$__propIsEnum.call(b, prop)) $26109f9d94d24593$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $26109f9d94d24593$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($26109f9d94d24593$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $26109f9d94d24593$var$__getOwnPropSymbols) {
        for (var prop of $26109f9d94d24593$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $26109f9d94d24593$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $26109f9d94d24593$export$5a3594759df1bd02(_a) {
    var _b = _a, { actions: actions, styles: styles, classNames: classNames, actionComponent: Action, hovered: hovered, onActionTrigger: onActionTrigger, query: query, nothingFoundMessage: nothingFoundMessage, highlightQuery: highlightQuery, highlightColor: highlightColor, radius: radius, variant: variant } = _b, others = $26109f9d94d24593$var$__objRest(_b, [
        "actions",
        "styles",
        "classNames",
        "actionComponent",
        "hovered",
        "onActionTrigger",
        "query",
        "nothingFoundMessage",
        "highlightQuery",
        "highlightColor",
        "radius",
        "variant"
    ]);
    const { classes: classes } = (0, $kREKv.default)(null, {
        name: "Spotlight",
        classNames: classNames,
        styles: styles,
        variant: variant
    });
    const items = actions.map((item)=>{
        if (item.type === "item") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Action, {
            query: query,
            key: item.item.id,
            action: item.item,
            hovered: item.index === hovered,
            classNames: classNames,
            styles: styles,
            radius: radius,
            onTrigger: ()=>onActionTrigger(item.item),
            highlightQuery: highlightQuery,
            highlightColor: highlightColor
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
            className: classes.actionsGroup,
            color: "dimmed",
            key: item.label
        }, item.label);
    });
    const shouldRenderActions = items.length > 0 || !!nothingFoundMessage && query.trim().length > 0;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, shouldRenderActions && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $26109f9d94d24593$var$__spreadValues({
        className: classes.actions
    }, others), items.length > 0 ? items : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        c: "dimmed",
        className: classes.nothingFound,
        ta: "center",
        fz: "lg",
        py: "md"
    }, nothingFoundMessage)));
}
$26109f9d94d24593$export$5a3594759df1bd02.displayName = "@mantine/spotlight/ActionsList";

});
parcelRegister("kREKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3085dc9ae3aca99$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $f3085dc9ae3aca99$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        nothingFound: {},
        actions: {
            padding: `calc(${theme.spacing.xs} / 2)`
        },
        actionsGroup: {
            textTransform: "uppercase",
            fontSize: theme.spacing.xs,
            fontWeight: 700,
            padding: `${(0, $2jkdX.rem)(10)} ${(0, $2jkdX.rem)(12)}`,
            paddingBottom: 0,
            paddingTop: theme.spacing.md
        }
    }));
var $f3085dc9ae3aca99$export$2e2bcd8739ae039 = $f3085dc9ae3aca99$var$useStyles;

});


parcelRegister("ZMGGu", function(module, exports) {

$parcel$export(module.exports, "filterActions", () => $0b9b76ef2add5214$export$c5ba3eb12f7d893);
function $0b9b76ef2add5214$var$getKeywords(keywords) {
    if (Array.isArray(keywords)) return keywords.map((keyword)=>keyword.trim()).join(",").toLowerCase().trim();
    if (typeof keywords === "string") return keywords.toLowerCase().trim();
    return "";
}
function $0b9b76ef2add5214$export$c5ba3eb12f7d893(_query, actions) {
    const query = _query.trim().toLowerCase();
    const priorityMatrix = [
        [],
        []
    ];
    actions.forEach((action)=>{
        var _a, _b;
        if ((_a = action.title) == null ? void 0 : _a.toLowerCase().includes(query)) priorityMatrix[0].push(action);
        else if (((_b = action.description) == null ? void 0 : _b.toLowerCase().includes(query)) || $0b9b76ef2add5214$var$getKeywords(action.keywords).includes(query)) priorityMatrix[1].push(action);
    });
    return priorityMatrix.flat();
}

});

parcelRegister("eOLeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9a60590d766596$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $ac9a60590d766596$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        content: {
            position: "relative",
            overflow: "hidden"
        },
        searchInput: {
            border: 0,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            "&, &:focus-within": {
                borderBottom: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}`
            }
        }
    }));
var $ac9a60590d766596$export$2e2bcd8739ae039 = $ac9a60590d766596$var$useStyles;

});


parcelRegister("4k1i9", function(module, exports) {

$parcel$export(module.exports, "useActionsState", () => $325a0832bde04b60$export$f3ef19f9d82b239);

var $45cdq = parcelRequire("45cdq");

var $acw62 = parcelRequire("acw62");
var $325a0832bde04b60$var$__defProp = Object.defineProperty;
var $325a0832bde04b60$var$__defProps = Object.defineProperties;
var $325a0832bde04b60$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $325a0832bde04b60$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $325a0832bde04b60$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $325a0832bde04b60$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $325a0832bde04b60$var$__defNormalProp = (obj, key, value)=>key in obj ? $325a0832bde04b60$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $325a0832bde04b60$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($325a0832bde04b60$var$__hasOwnProp.call(b, prop)) $325a0832bde04b60$var$__defNormalProp(a, prop, b[prop]);
    if ($325a0832bde04b60$var$__getOwnPropSymbols) {
        for (var prop of $325a0832bde04b60$var$__getOwnPropSymbols(b))if ($325a0832bde04b60$var$__propIsEnum.call(b, prop)) $325a0832bde04b60$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $325a0832bde04b60$var$__spreadProps = (a, b)=>$325a0832bde04b60$var$__defProps(a, $325a0832bde04b60$var$__getOwnPropDescs(b));
function $325a0832bde04b60$var$prepareAction(action) {
    return $325a0832bde04b60$var$__spreadProps($325a0832bde04b60$var$__spreadValues({}, action), {
        id: action.id || (0, $45cdq.randomId)()
    });
}
function $325a0832bde04b60$var$filterDuplicateActions(actions) {
    const ids = new Set();
    return actions.reduceRight((acc, action)=>{
        if (!ids.has(action.id)) {
            ids.add(action.id);
            acc.push(action);
        }
        return acc;
    }, []).reverse();
}
function $325a0832bde04b60$var$prepareActions(initialActions) {
    return $325a0832bde04b60$var$filterDuplicateActions(initialActions.map((action)=>$325a0832bde04b60$var$prepareAction(action)));
}
function $325a0832bde04b60$export$f3ef19f9d82b239({ actions: actions, onActionsChange: onActionsChange }) {
    const preparedActions = (0, $acw62.useMemo)(()=>$325a0832bde04b60$var$prepareActions(actions), [
        actions
    ]);
    const registerActions = (payload)=>onActionsChange == null ? void 0 : onActionsChange($325a0832bde04b60$var$prepareActions([
            ...actions,
            ...payload
        ]));
    const removeActions = (ids)=>onActionsChange == null ? void 0 : onActionsChange(actions.filter((action)=>!ids.includes(action.id)));
    const triggerAction = (id)=>{
        var _a;
        const action = actions.find((item)=>item.id === id);
        (_a = action == null ? void 0 : action.onTrigger) == null || _a.call(action, action);
    };
    return [
        preparedActions,
        {
            registerActions: registerActions,
            removeActions: removeActions,
            triggerAction: triggerAction
        }
    ];
}

});

parcelRegister("1H7ml", function(module, exports) {

$parcel$export(module.exports, "useSpotlightShortcuts", () => $13bf840b070d3817$export$5c3c68998cb9b87c);

var $jqu36 = parcelRequire("jqu36");
function $13bf840b070d3817$export$a7db57850824b270(shortcuts, onToggle) {
    if (shortcuts === null) return [];
    if (Array.isArray(shortcuts)) return shortcuts.map((shortcut)=>[
            shortcut,
            onToggle
        ]);
    return [
        [
            shortcuts,
            onToggle
        ]
    ];
}
function $13bf840b070d3817$export$5c3c68998cb9b87c(shortcuts, onToggle, tagsToIgnore, triggerOnContentEditable) {
    (0, $jqu36.useHotkeys)($13bf840b070d3817$export$a7db57850824b270(shortcuts, onToggle), tagsToIgnore, triggerOnContentEditable);
}

});


parcelRegister("kF50T", function(module, exports) {

$parcel$export(module.exports, "getMenusAndRedirectToHome", () => $957503755d991fe3$export$a1cc628be5774e18);
async function $957503755d991fe3$export$a1cc628be5774e18(client, no_redirect) {
    const menus = await client.getMenus();
    const hasBackoffice = menus ? [
        ...menus
    ].some((menu)=>menu.startsWith("BackofficeMenu_")) : false;
    const hasClientsHome = menus ? [
        ...menus
    ].some((menu)=>menu.startsWith("ClientesHomeMenu_")) : false;
    if (!no_redirect) {
        if (hasBackoffice) {
            if (window.location.pathname !== '/') window.location.href = '/';
        } else if (hasClientsHome) {
            if (!window.location.pathname.startsWith('/clienteshome')) window.location.href = '/clienteshome';
        }
    }
}

});

parcelRegister("7qrj2", function(module, exports) {

$parcel$export(module.exports, "LoggedInMenu", () => $22815d5f060a63a3$export$51eb49c589dd817e);

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $9mTYo = parcelRequire("9mTYo");
var $aUqRb = parcelRequire("aUqRb");
var $64A2P = parcelRequire("64A2P");

var $49qEn = parcelRequire("49qEn");

var $jXcTK = parcelRequire("jXcTK");
function $22815d5f060a63a3$export$51eb49c589dd817e({ loggedInUser: loggedInUser, initials: initials, enabledMenus: enabledMenus, onLogOut: onLogOut, photoURL: photoURL, onEditProfile: onEditProfile }) {
    const theme = (0, $64A2P.useMantineTheme)();
    const openform = (0, $49qEn.useOpenForm)();
    const hasBackoffice = enabledMenus ? [
        ...enabledMenus
    ].some((menu)=>menu.startsWith("BackofficeMenu_")) : false;
    const hasClientesHome = enabledMenus ? [
        ...enabledMenus
    ].some((menu)=>menu.startsWith("ClientesHomeMenu_")) : false;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aUqRb.Menu), {
            withArrow: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aUqRb.Menu).Target, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                        src: photoURL || null,
                        alt: loggedInUser,
                        radius: "xl",
                        color: "red",
                        style: {
                            border: theme.colorScheme === 'dark' ? `2px solid ${theme.colors.dark[0]}` : `2px solid ${theme.colors.dark[9]}`
                        },
                        children: photoURL ? undefined : initials
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aUqRb.Menu).Dropdown, {
                    children: [
                        hasBackoffice && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aUqRb.Menu).Item, {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jXcTK.default), {
                                        size: "1rem"
                                    }),
                                    onClick: async ()=>{
                                        await onEditProfile(openform);
                                    },
                                    children: "Editar perfil"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aUqRb.Menu).Divider, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aUqRb.Menu).Item, {
                            onClick: async ()=>{
                                await onLogOut();
                            },
                            children: "Cerrar sesi\xf3n"
                        })
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("jXcTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f95d16a2976d41b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $0f95d16a2976d41b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10 9a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4 8v-2a2 2 0 0 1 2 -2h2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M4 16v2a2 2 0 0 0 2 2h2",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M16 4h2a2 2 0 0 1 2 2v2",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M16 20h2a2 2 0 0 0 2 -2v-2",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M8 16a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2",
            "key": "svg-5"
        }
    ]
];
const $0f95d16a2976d41b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user-scan", "UserScan", $0f95d16a2976d41b$export$3efd853dbb351e94);

});


parcelRegister("lCDNR", function(module, exports) {

$parcel$export(module.exports, "PerfilUsuario", () => $e5c6635ce522fc8f$export$2e1ac9154db307c9);

var $49qEn = parcelRequire("49qEn");

var $9HcD3 = parcelRequire("9HcD3");

class $e5c6635ce522fc8f$export$2e1ac9154db307c9 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $9HcD3.PerfilUsuarioDef)(), parentKeys);
        this.Form = (parcelRequire("4IY0j")).then((module)=>module.PerfilUsuarioForm);
        this.Title = "Tu perfil";
    }
}

});
parcelRegister("9HcD3", function(module, exports) {

$parcel$export(module.exports, "PerfilUsuarioDef", () => $f82e56843cd15611$export$322dd55cd483ec16);

var $49qEn = parcelRequire("49qEn");
const $f82e56843cd15611$var$columns = ()=>({
        vc_username: new (0, $49qEn.EntityColumn)({
            name: 'vc_username',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Username'
        }),
        c_fotofileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fotofileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotofileprocess Id'
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotoguid'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Apellido'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $f82e56843cd15611$var$views = ()=>({
        pfus_brwStandard: {
            name: 'pfus_brwStandard',
            keyMappings: {
                vc_username: 0
            }
        }
    });
class $f82e56843cd15611$export$322dd55cd483ec16 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PerfilUsuario'), this.columns = $f82e56843cd15611$var$columns(), this.views = $f82e56843cd15611$var$views();
    }
}

});

parcelRegister("4IY0j", function(module, exports) {
module.exports = import("8FiY6").then(()=>parcelRequire('i3hLE'));

});


parcelRegister("5Ue5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $144c7e7ebc95e3c5$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $144c7e7ebc95e3c5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M13.45 11.55l2.05 -2.05",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6.4 20a9 9 0 1 1 11.2 0z",
            "key": "svg-2"
        }
    ]
];
const $144c7e7ebc95e3c5$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "dashboard", "Dashboard", $144c7e7ebc95e3c5$export$3efd853dbb351e94);

});

parcelRegister("283Rc", function(module, exports) {

$parcel$export(module.exports, "ClientesVmiHelpText", () => $2506bb18c7b5bddb$export$a87803d6401ce25b);
$parcel$export(module.exports, "ClientesVmi", () => $2506bb18c7b5bddb$export$cb04ea1ad82d91d5);

var $49qEn = parcelRequire("49qEn");

var $9Cu5z = parcelRequire("9Cu5z");

var $fVyGB = parcelRequire("fVyGB");
const $2506bb18c7b5bddb$export$cc790f43fbe46773 = (0, $9Cu5z.default);
const $2506bb18c7b5bddb$export$a87803d6401ce25b = "* Importaci\xf3n de Archivos.";

class $2506bb18c7b5bddb$export$cb04ea1ad82d91d5 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $fVyGB.ClientesVmiDef)(), parentKeys);
        this.Form = (parcelRequire("asJQQ")).then((module)=>module.ClientesVmiForm);
        this.Title = "Importaci\xf3n de Archivos";
        this.HelpText = $2506bb18c7b5bddb$export$a87803d6401ce25b;
        this.Icon = $2506bb18c7b5bddb$export$cc790f43fbe46773;
    }
}

});
parcelRegister("9Cu5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bac14b023a04ca5$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7bac14b023a04ca5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M14 3v4a1 1 0 0 0 1 1h4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
            "key": "svg-1"
        }
    ]
];
const $7bac14b023a04ca5$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "file", "File", $7bac14b023a04ca5$export$3efd853dbb351e94);

});

parcelRegister("fVyGB", function(module, exports) {

$parcel$export(module.exports, "ClientesVmiDef", () => $be390510c5f14fbb$export$46df7e3d4ec619c6);

var $49qEn = parcelRequire("49qEn");

var $lC5aj = parcelRequire("lC5aj");
const $be390510c5f14fbb$var$columns = ()=>({
        c_proceso_vmi_id: new (0, $49qEn.EntityColumn)({
            name: 'c_proceso_vmi_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Proceso Vmi Id'
        }),
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Cliente Id'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Fileprocess Id'
        }),
        vc_errores: new (0, $49qEn.EntityColumn)({
            name: 'vc_errores',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Errores'
        }),
        vc_filepath: new (0, $49qEn.EntityColumn)({
            name: 'vc_filepath',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Filepath'
        }),
        c_tipoexcel_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipoexcel_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Formato de excel'
        }),
        c_cliente_backoffice_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_backoffice_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cliente Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $be390510c5f14fbb$var$views = ()=>({
        cvmi_brwStandard: {
            name: 'cvmi_brwStandard',
            keyMappings: {
                c_proceso_vmi_id: 0
            }
        },
        cvmi_brwPorClienteBackoffice: {
            name: 'cvmi_brwPorClienteBackoffice',
            keyMappings: {
                c_proceso_vmi_id: 0
            }
        }
    });
const $be390510c5f14fbb$var$lookups = ()=>({
        'TiposExcel': {
            name: 'TiposExcel',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $lC5aj.catTiposExcel)(client, parentKeys)
        }
    });
class $be390510c5f14fbb$export$46df7e3d4ec619c6 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesVmi'), this.columns = $be390510c5f14fbb$var$columns(), this.views = $be390510c5f14fbb$var$views(), this.lookups = $be390510c5f14fbb$var$lookups();
    }
}

});
parcelRegister("lC5aj", function(module, exports) {

$parcel$export(module.exports, "catTiposExcel", () => $fa3d4b96a46564f5$export$74ec30ed20e57115);

var $49qEn = parcelRequire("49qEn");

var $9Cu5z = parcelRequire("9Cu5z");
const $fa3d4b96a46564f5$export$53b4661945d7afc = (0, $9Cu5z.default);
const $fa3d4b96a46564f5$export$3f33dcd52977b83e = "* Aqu\xed puede ver los tipos de excel.";
class $fa3d4b96a46564f5$export$74ec30ed20e57115 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposExcel";
        this.def.columns.c_category_id.defaultValue = "TiposExcel";
        this.Title = "Tipos de Excel";
        this.HelpText = $fa3d4b96a46564f5$export$3f33dcd52977b83e;
        this.Icon = $fa3d4b96a46564f5$export$53b4661945d7afc;
    }
}

});


parcelRegister("asJQQ", function(module, exports) {
module.exports = import("AN4au").then(()=>parcelRequire('49nyR'));

});


parcelRegister("elPjY", function(module, exports) {

$parcel$export(module.exports, "DashboardClientes", () => $80202ce401384975$export$2069b88a6f6d4694);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $16Apf = parcelRequire("16Apf");
const $80202ce401384975$export$2fe885f67f75faa = (0, $5Ue5f.default);
const $80202ce401384975$export$fa2da6901617fd9f = '* Dashboard.';

class $80202ce401384975$export$2069b88a6f6d4694 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $16Apf.DashboardClientesDef)(), parentKeys);
        this.Form = (parcelRequire("aVTqU")).then((module)=>module.DashboardClientesForm);
        this.Title = "Dashboard Clientes";
        this.HelpText = $80202ce401384975$export$fa2da6901617fd9f;
        this.Icon = $80202ce401384975$export$2fe885f67f75faa;
    }
}

});
parcelRegister("16Apf", function(module, exports) {

$parcel$export(module.exports, "DashboardClientesDef", () => $192c54bc91914c80$export$f7b174796bdfd3c8);

var $49qEn = parcelRequire("49qEn");
const $192c54bc91914c80$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Cliente ID'
        }),
        vc_url_dashboard: new (0, $49qEn.EntityColumn)({
            name: 'vc_url_dashboard',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'URL Dashboard Clientes'
        }),
        vc_workspace_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_workspace_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Workspace Id'
        }),
        vc_report_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_report_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Report Id'
        }),
        vc_token: new (0, $49qEn.EntityColumn)({
            name: 'vc_token',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Token'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $192c54bc91914c80$var$views = ()=>({});
const $192c54bc91914c80$var$clientActions = ()=>({});
class $192c54bc91914c80$export$f7b174796bdfd3c8 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DashboardClientes'), this.columns = $192c54bc91914c80$var$columns(), this.views = $192c54bc91914c80$var$views(), this.clientActions = $192c54bc91914c80$var$clientActions();
    }
}

});

parcelRegister("aVTqU", function(module, exports) {
module.exports = Promise.all([
    import("j0t1y"),
    import("OQm3w")
]).then(()=>parcelRequire('bl3zy'));

});



//# sourceMappingURL=html.53069f58.js.map
